import { createStore } from 'vuex';
import axios from '../../node_modules/axios/dist/axios';
import router from '../router';

export default createStore({
	state: {
		isAuthentic: false,
		token: '',
		role:'',
	},
	mutations: {

		userRoleUpdate(state, role) {
			localStorage.setItem('userRoleUpdate', role);
			state.role = role;
		},
		onStart(state) {
			let token = localStorage.getItem('token');
			let role = localStorage.getItem('userRoleUpdate');
			if (token) {
				state.isAuthentic = true;
				state.token = token;
				state.role = role;
				axios.defaults.headers.common['Authorization'] =
					'Bearer ' + token;
			} else {
				state.isAuthentic = false;
				state.token = '';
				axios.defaults.headers.common['Authorization'] = '';
			}
		},
		logIn(state,token) {
			if (token) {
				state.isAuthentic = true;
				state.token = token;
				localStorage.setItem('token', token);
				axios.defaults.headers.common['Authorization'] =
					'Bearer ' + token;
			} else {
				state.isAuthentic = false;
				state.token = '';
				localStorage.removeItem('token');
				axios.defaults.headers.common['Authorization'] = '';
			}
		},
		logOut(state) {
			state.isAuthentic = false;
			state.token = '';
			state.role='';
			axios.defaults.headers.common['Authorization'] = '';
			localStorage.removeItem('token');
		},
	},
	actions: {
		onStart(context) {
			let token = localStorage.getItem('token');
			if (token) {
				axios.defaults.headers.common['Authorization'] =
					'Bearer ' + token;
				axios
					.get('/api/user')
					.then((response) => {
						context.commit('logIn', token);
					})
					.catch((error) => {
						context.commit('logOut');
						router.push('/login');
						console.log(error);
					});
			} else {
				context.commit('logOut');
				router.push('/login');
			}
		},
	},
	modules: {},
});
